<template>
  <component :is="cardComponent" :log="log" />
</template>

<script>
import { ReservationLogType } from '@/Enums/ReservationLogType'
import LogCardCreated from './LogCardCreated'
import LogCardPaid from './LogCardPaid'
import LogCardDeleted from './LogCardDeleted'
import LogCardExpired from './LogCardExpired'
import LogCardMoved from './LogCardMoved'

const TYPE_COMPONENTS = {
  [ReservationLogType.CREATED]: LogCardCreated,
  [ReservationLogType.PAID]: LogCardPaid,
  [ReservationLogType.DELETED]: LogCardDeleted,
  [ReservationLogType.EXPIRED]: LogCardExpired,
  [ReservationLogType.MOVED]: LogCardMoved,
}

export default {
  props: {
    log: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cardComponent() {
      return TYPE_COMPONENTS[this.log.type_id] || LogCardCreated
    },
  },
}
</script>
